import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { CarCategoryRoomPriceFindDto, type CarCategoryRoomPriceFindInterface } from '@zaoblako/shared/modules/cctv/dtos/car-category/room-price/car-category-room-price-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CctvDtoKeysEnum } from '@zaoblako/shared/modules/cctv/enums/cctv-dto-keys.enum';

import * as yup from 'yup';

/** Car category response body */
export interface CarCategoryFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;

  // Tech columns
  /** Creation date and time */
  created: Date;
  /** Last update date and time */
  updated: Date;
  /** Soft deletion update date and time. The camera will be permanently deleted six months after this date. */
  deleted?: Date;
  /** The user who created this car category */
  createdBy?: UserFindInterface;

  // Data columns
  /** Category name */
  name: string;
  /** Default car category */
  isDefault: boolean;
  /** Is this car category hidden in personal account mode? */
  personalAccountHidden?: boolean;
  /** Is transit tasks limits enabled for this category? */
  transitTaskLimitsEnabled?: boolean;
  /** Prices for parking of this category of cars for rooms */
  roomPrices?: CarCategoryRoomPriceFindInterface[];
}

/** Car category response body - DTO schema */
export const CarCategoryFindDto = SerdeDtoClass.create<CarCategoryFindInterface>(CctvDtoKeysEnum.CAR_CATEGORY_FIND_DTO, {
  id: {
    sortable: true,
    label: 'Номер',
    serializer: yup.number(),
  },
  created: {
    sortable: true,
    label: 'Создана',
    serializer: yup.date(),
  },
  updated: {
    sortable: true,
    label: 'Изменена',
    serializer: yup.date(),
  },
  deleted: {
    optional: true,
    label: 'Удалена',
    serializer: yup.date(),
  },
  createdBy: {
    optional: true,
    sortable: true,
    label: 'Автор',
    nested: UserFindDto,
    serializer: (_, nested) => nested,
  },
  name: {
    sortable: true,
    label: 'Название категории ТС',
    serializer: yup.string(),
  },
  isDefault: {
    label: 'По умолчанию',
    serializer: yup.boolean(),
  },
  personalAccountHidden: {
    optional: true,
    label: 'Скрывать в ЛК',
    serializer: yup.boolean(),
  },
  transitTaskLimitsEnabled: {
    optional: true,
    label: 'Можно установить лимит',
    serializer: yup.boolean(),
  },
  roomPrices: {
    optional: true,
    label: 'Цена за час по помещениям',
    nested: CarCategoryRoomPriceFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
});
